import { Box, Button as MuiButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Button from 'src/modules/common/components/Button/Button';
import theme from 'src/styles/theme';

import useActivity from '../../application/use-activity';
import ActivityTable from '../ActivityTable/ActivityTable';

const ActivityContainer = ({ showMoreButton }: { showMoreButton: boolean }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, handleFetchMore, loading } = useActivity();

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          backgroundColor: theme.palette.colors.white,
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: `${theme.palette.divider} !important`,
          padding: '2rem',
          borderRadius: '10px',
          marginTop: '1rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <Typography variant="h5" sx={{ mb: '1rem' }}>
            {t('modules.home.recentActivities.title')}
          </Typography>
          {!showMoreButton && (
            <MuiButton
              onClick={() => {
                navigate('/recent-activity');
              }}
              sx={{
                '&:hover': {
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                },
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                {t('modules.home.recentActivities.viewAll')}
              </Typography>
            </MuiButton>
          )}
        </Box>
        <ActivityTable data={data} />
      </Box>
      {showMoreButton && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            mt: '1rem',
          }}
        >
          <Button
            variant="outlined"
            size="small"
            onClick={handleFetchMore}
            loading={loading}
            sx={{
              '&:hover': {
                backgroundColor: 'transparent',
                boxShadow: 'none',
              },
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              {t('modules.home.recentActivities.showMore')}
            </Typography>
          </Button>
        </Box>
      )}
    </>
  );
};

export default ActivityContainer;
